import { Feature } from 'config/features';

interface BasicBackendInformation {
    features: Feature[];
}

export function getBackendInformation<Type>(): Type & BasicBackendInformation {
    const dataWrapper = document.getElementById('js-backend-information');
    return dataWrapper ? JSON.parse(dataWrapper.innerText) : { features: [] };
}
